import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppServices } from "../../../hook/services";
import DataTable from "./components/DataTable";
import LoadingScreen from "../../../components/LoadingScreen";

const PhoneNumbers = () => {
  const AppService = useAppServices();
  const [processing, setProcessing] = useState(true);
  const [loading, setLoading] = useState(true);
  const [numbers, setNumbers] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const { locationId } = useParams();
  const [account, setAccount] = useState({});

  const getData = async () => {
    const { response } = await AppService.sim.get({
      query: `locationId=${locationId}`,
    });
    if (response) {
      setNumbers(response.data);
    }
    setLoading(false);
  };
  const getAccount = async () => {
    const { response } = await AppService.account.filter({
      query: `id=${locationId}`,
    });
    if (response) {
      setAccount(response.data);
    }
  };
  useEffect(() => {
    getAccount();
    getData();
  }, []);

  const ConfigureNumber = async (number) => {
    setProcessing(true);
    setSelectedNumber(number);
    const payload = {
      defaultSim: number,
      id: locationId,
    };

    console.log("Form submitted with values:", payload);
    const { response } = await AppService.account.update_by_id({ payload });
    if (response) {
      getAccount();
    }
    setProcessing(false);
    setSelectedNumber(null);
  };
  const columns = [
    {
      label: "Phone",
      accessor: "sim_number",
      sortable: true,
      renderCell: (row) => (
        <>
          <span className="text-dark fw-semibold">{row.sim_number || "-"}</span>
          {account?.defaultSim && account?.defaultSim == row._id && (
            <span className="badge bg-light text-dark border px-3 py-2 rounded-pill">
              default
            </span>
          )}
        </>
      ),
    },
    {
      label: "Sim Slot",
      accessor: "sim_slot",
      renderCell: (row) => (
        <>
          <span className="badge bg-light text-dark border px-3 py-2 rounded-pill">
            {row.sim_slot || "-"}
          </span>
        </>
      ),
    },
    {
      label: "Actions",
      accessor: "actions",
      renderCell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          {account?.defaultSim === row._id ? (
            <button
              disabled
              className="btn btn-success btn-sm rounded-3 shadow-sm d-flex align-items-center gap-2"
            >
              <i className="bi bi-check-circle-fill"></i>
              Configured
            </button>
          ) : (
            <button
              disabled={processing && selectedNumber === row._id}
              className="btn btn-primary btn-sm rounded-3 shadow-sm d-flex align-items-center gap-2"
              onClick={() => ConfigureNumber(row._id)}
            >
              {processing && selectedNumber === row._id ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing...
                </>
              ) : (
                <>
                  <i className="bi bi-sim me-1"></i>
                  Make Default
                </>
              )}
            </button>
          )}
        </div>
      ),
    },
  ];

  if (loading) {
    return <LoadingScreen loadingText={"Loading numbers..."} />;
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
      <div className="container-fluid p-4">
        {/* Header Card */}
        <div
          className="card border-0 shadow-sm mb-4"
          style={{ backgroundColor: "white" }}
        >
          <div className="card-body py-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-1 fw-bold text-dark">Phone Numbers</h4>
                <p className="text-muted mb-0 small">
                  Manage your phone numbers
                </p>
              </div>
            </div>
          </div>
        </div>
        <DataTable columns={columns} data={numbers} entriesPerPage={10} />
      </div>
    </div>
  );
};

export default PhoneNumbers;
